import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useIcons from '@/composables/useIcons'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useCommonMixin from '@/composables/useCommonMixin'
  import CourseApi from '@/services/api/CourseApi'
  import useCourse from '@/composables/useCourse'
  import useSegment from '@/composables/useSegment'
  import useEditor from '@/composables/useEditor'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import type { Nullable } from '@/services/interfaces/Content'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  props: {
    lessonId: {
      type: String,
      required: true,
    },
    lessonName: {
      type: String,
      required: true,
    },
    questionId: {
      type: String,
      required: true,
    },
    questionTitle: {
      type: String,
      required: true,
    },
    showRating: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const route = useRoute()
  const { starIcon } = useIcons()
  const { stripHtmlTagsFromString } = useCommonMixin()
  const { lessonFeedbackProvided, questionFeedbackProvided } = useSegment()
  const { course, currentCourseId, currentModule, moduleId } = useCourse()
  const { decodeAndParseSource } = useEditor(route)
  const { translateString } = useI18n()

  const comment = ref('')
  const rating = ref(0)

  const hoverIndex = ref(0)
  const submittingFeedback = ref(false)
  const messageBox = ref(null as Nullable<HTMLTextAreaElement>)

  const postLessonFeedback = async () => {
    await CourseApi.postLessonFeedback(currentCourseId.value, moduleId.value, {
      comment: comment.value,
      lessonId: props.lessonId,
      rating: rating.value,
    }).finally(() => {
      lessonFeedbackProvided(
        currentCourseId.value,
        course.value!.title,
        moduleId.value,
        currentModule.value.name,
        props.lessonId,
        props.lessonName,
        comment.value,
        rating.value > 0 ? rating.value : null,
      )
    })
  }

  const postQuestionFeedback = async () => {
    await CourseApi.postQuestionFeedback(
      props.questionId,
      stripHtmlTagsFromString.value(decodeAndParseSource(props.questionTitle)),
      comment.value,
    ).finally(() => {
      questionFeedbackProvided(
        currentCourseId.value,
        course.value!.title,
        props.questionId,
        stripHtmlTagsFromString.value(decodeAndParseSource(props.questionTitle)),
        comment.value,
      )
    })
  }

  const onFeedbackSubmit = async () => {
    if (comment.value) {
      submittingFeedback.value = true
      if (props.lessonId && props.lessonName) {
        await postLessonFeedback()
      } else {
        await postQuestionFeedback()
      }
      submittingFeedback.value = false
      eventBus.$toasted.success(translateString('feedback.successMessage'))
      emit('close')
    } else {
      eventBus.$toasted.error(translateString('feedback.errorMessage'))
    }
  }

  onMounted(() => {
    if (messageBox.value) {
      messageBox.value.focus()
    }
  })

return { __sfc: true,props, emit, route, starIcon, stripHtmlTagsFromString, lessonFeedbackProvided, questionFeedbackProvided, course, currentCourseId, currentModule, moduleId, decodeAndParseSource, translateString, comment, rating, hoverIndex, submittingFeedback, messageBox, postLessonFeedback, postQuestionFeedback, onFeedbackSubmit, onMounted, ref, KetchUpButton, LoadingSpinner, useIcons, SVGRenderer, useCommonMixin, CourseApi, useCourse, useSegment, useEditor, eventBus, useI18n, useRoute }
}

})